export { TripList, type TripListProps } from "./TripList";
